import React from 'react'
import { RouteConstants } from '../navigation/navigation-types'
import { Tab } from '@mui/material'
import LinkWrapper from './common/LinkWrapper'
import { UserRole } from '../services/api/sharedTypes/User'
import { useAppSelector } from '../hooks/reduxHooks'
import { getAuthState } from '../services/redux/auth/auth-selectors'

interface NavbarCustomTabProps {
    label: string
    value: number
    route: RouteConstants
    allowedRoles?: UserRole[]
}

const NavbarCustomTab: React.FC<NavbarCustomTabProps> = ({ label, value, route, allowedRoles }: NavbarCustomTabProps) => {
    const { role: userRole } = useAppSelector(getAuthState)
    const hasAccess = allowedRoles && allowedRoles.includes(userRole);

    if (userRole !== UserRole.Admin && (!hasAccess || !allowedRoles)) {
        return null
    }

    return (
        <LinkWrapper route={route} style={{ maxHeight: 50 }}>
            <Tab wrapped label={label} value={value} />
        </LinkWrapper>
    )
}

export default NavbarCustomTab
